<template>
  <xui-footer class="footer-wrap">
    <xui-dialog 
    title="" 
    class="warnning-wrap" 
    :showcenter="true" 
    :close-on-click-modal="false" 
    :visible.sync="dialogVisible" 
    :width="$store.state.isMobile ? '80%' : '20%'" 
    :before-close="handleClose"
    >
    <div v-if="dialogVisible&&!show1046&&!show1047">
      <h2 :style="{ 'font-size': $store.state.isMobile ? '24px' : '16.5px' } + ';text-align: center;'">隐私通知</h2>
          <div class="content-wrap" :style="{ 'font-size': $store.state.isMobile ? '22px' : '14px' }">
          </br>
            <div>
              荣耀安全应急响应中心需联网，需收集您的身份信息、交易信息，我们仅在使用具体业务功能时才触发上述行为收集使用相关的个人信息。
            </div>
          </br>
            <div>
             本服务为您提供账号登录、漏洞提交、漏洞奖金支付等业务功能，点击“同意”，即表示您同意
              <span @click="handleLink(safetyURL)" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</span> 、
              <span @click="handleLink(privacyURL)" class="honor-security-secret-statement">关于荣耀安全应急响应中心与隐私的声明</span>。
            </div>
          </div>
    </div>

    <div v-if="dialogVisible&&show1046&&!show1047">
      <h2 :style="{ 'font-size': $store.state.isMobile ? '24px' : '16.5px' } + ';text-align: center;'">变更通知</h2>
          <div class="content-wrap" :style="{ 'font-size': $store.state.isMobile ? '22px' : '14px' }">
          </br>
            <div>
              为提供更好的服务，我们更新了用户协议，请您仔细阅读变更详情，并充分理解相关条款。
            </div>
            </br>
            <div>
              用户协议调整如下：
            </div>
            <div>
            {{  content1046}}
            </div>
          </br>
            <div>
              详细内容请参阅最新的
              <span @click="handleLink(safetyURL)" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</span> 。 
              点击“同意”，即表示您同意变更内容，同意后可继续使用本服务。
            </div>
          </div>
    </div>

    <div v-if="dialogVisible&&show1047&&!show1046">
      <h2 :style="{ 'font-size': $store.state.isMobile ? '24px' : '16.5px' } + ';text-align: center;'">变更通知</h2>
          <div class="content-wrap" :style="{ 'font-size': $store.state.isMobile ? '22px' : '14px' }">
          </br>
            <div>
              为提供更好的服务，我们更新了隐私声明，请您仔细阅读变更详情，并充分理解相关条款。
            </div>
            </br>
            <div>
              隐私声明调整如下：
            </div>
            <div>
            {{  content1047}}
            </div>
          </br>
            <div>
              详细内容请参阅最新的
              <span @click="handleLink(privacyURL)" class="honor-security-secret-statement">关于荣耀安全应急响应中心与隐私的声明</span>。 
              点击“同意”，即表示您同意变更内容，同意后可继续使用本服务。
            </div>
          </div>
    </div>

    <div v-if="dialogVisible&&show1047&&show1046">
      <h2 :style="{ 'font-size': $store.state.isMobile ? '24px' : '16.5px' } + ';text-align: center;'">变更通知</h2>
          <div class="content-wrap" :style="{ 'font-size': $store.state.isMobile ? '22px' : '14px' }">
          </br>
            <div>
              为提供更好的服务，我们更新了用户协议和隐私声明，请您仔细阅读变更详情，并充分理解相关条款。
            </div>
            </br>
            <div>
              用户协议调整如下：
            </div>
            <div>
            {{  content1046}}
            </div>
          </br>
            <div>
              隐私声明调整如下：
            </div>
            <div>
            {{  content1047}}
            </div>
          </br>
            <div>
              详细内容请参阅最新的
              <span @click="handleLink(safetyURL)" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</span> 、
              <span @click="handleLink(privacyURL)" class="honor-security-secret-statement">关于荣耀安全应急响应中心与隐私的声明</span>。 
              点击“同意”，即表示您同意变更内容，同意后可继续使用本服务。
            </div>
          </div>
    </div>
      <span slot="footer" class="dialog-footer" center>
        <xui-button size="bigger" @click="handleClose">取消</xui-button>
        <xui-button type="primary" size="bigger" @click="confirm">同意</xui-button>
      </span>
    </xui-dialog>
    <div class="footer-con">
      <div class="footer-links">
        <!-- <span><a href="" target="_blank">荣耀PSIRT</a></span> -->
        <!-- <div class="xui-divider xui-divider--vertical"></div> -->
        <a class="footer-link" :href="safetyURL" target="_blank">用户协议</a>
        <router-link class="footer-link" to="/report" exact>提交漏洞</router-link>
        <a class="footer-link" :href="privacyURL" target="_blank">隐私声明</a>
        <a class="footer-link" href="mailto:security@honor.com" target="_blank">联系我们</a>
        <a class="footer-link" :href="cookieUrl" target="_blank">Cookie</a>
      </div>
      <div class="copyright">
        <span class="copyright-txt">版权所有 © 荣耀终端股份有限公司 2020-{{ nowYear }} 保留一切权利。</span>
        <a class="copyright-txt copyright-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002002883" rel="noreferrer" target="_blank">
          <img src="../images/ghs.png" />粤公网安备 44030002002883</a>
        <a style="padding-left: 10px" class="copyright-txt" target="_blank" href="http://beian.miit.gov.cn/" rel="nofollow"><span>粤ICP备20047157号</span></a>
      </div>
    </div>
  </xui-footer>
</template>
<script>
export default {
  name: 'footerPage',
  data() {
    return {
      str: 'Footer Page',
      nowYear: new Date().getFullYear(),
      safetyURL: '',
      privacyURL: '',
      cookieUrl: '',
      dialogVisible: false,
      xCsrfToken: null,
      show1046: false,
      show1047: false,
      content1046: '',
      content1047: ''
    };
  },
  mounted() {
    this.$http
      .get('vul/hsrc/vul/report/services/banner/ams/list')
      .then(res => {     
         if ('200' === res.data.status + '' && res.data.data) {
        window.sessionStorage.setItem('privacyURL', res.data.data.privacyStatementUrl);
        window.sessionStorage.setItem('safetyURL', res.data.data.userAgreementUrl);
        window.sessionStorage.setItem('cookieUrl', res.data.data.cookieUrl);
        this.safetyURL = window.sessionStorage.getItem('safetyURL');
        this.privacyURL = window.sessionStorage.getItem('privacyURL');
        this.cookieUrl = window.sessionStorage.getItem('cookieUrl');
      }
    });
    setTimeout(() => {
      this.getUserInfo();
    }, 500);
  },
  methods: {
    // 获取token
    getCSRF: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', {
            headers: {
              'x-multi-consumer-appid': 'hsrc_vul-x-service-multi',
              appid: this.$appId,
              'x-celon-admin': true,
              'x-sub-app-id': 'hsrc_vul',
              'x-csrf-token': window.sessionStorage.getItem('x-csrf-token')
            }
          })
          .then(res => {
            window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
            // 2.校验是否需要签名
            this.query();
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 确实是否登录
    getUserInfo: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
              // 如果是登录状态，就验证是否签名
              // 1.获取token值
              this.getCSRF();
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    query() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            console.log('query >>> ', res);
            // 4.如果需要签名，弹出签名窗口
            const signInfoList = res.data.signInfo;
            if (!signInfoList || signInfoList.length === 0) {
              //没有签过 直接弹
              setTimeout(() => {
                this.dialogVisible = true;
              }, 1000);
            } else {
              //有签过 判断是否需要更新
              const arr = signInfoList
                .filter(item => item.needSign)
                .map(el => {
                  return {
                    agrType: el.agrType,
                    country: el.country,
                    branchId: el.branchId,
                    version: el.newestVersion,
                    language: 'zh-cn'
                  };
                });
              if (arr.length > 0) {
                this.getAmsData(arr);
                setTimeout(() => {
                  this.dialogVisible = true;
                }, 1000);
              } else {
                //不需要更新
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    handleClose: function() {
      this.dialogVisible = false;
      this.$router.push({ path: '/' });
      setTimeout(() => {
        this.getUserInfo();
      }, 500);
    },
    getAmsVersion: function () {
      // const Token = window.sessionStorage.getItem('x-csrf-token');
      this.$http.get('vul/hsrc/vul/report/services/autograph/getVersion', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
        .then(async res => {
          console.log('getVersion >>> ', res);
          if (res.status === 200 && res.data && res.data.data) {
            let list = [];
            for (let i in res.data.data) {
              if (res.data.data[i].needSign) {
                const params = {
                  agrType: res.data.data[i].agrType,
                  country: res.data.data[i].country,
                  branchId: res.data.data[i].branchId,
                  version: res.data.data[i].latestVersion,
                  language: 'zh-cn'
                };
                list.push(params);
              }
            };
            this.getAmsData(list);
          } else {
            console.log('退出接口userLogout返回失败，res.status不是200！');
          }
        })
        .catch(error => {
          console.log('getAmsVersion',error);
        });
    },
    getAmsData: function(val) {
      const Token = window.sessionStorage.getItem('x-csrf-token');
      const params = {
        queryInfoList: val
      };
      this.$http
        .post('vul/hsrc/vul/report/services/autograph/getArgContent', params, { headers: { 'x-csrf-token': Token } })
        .then(res => {
          if (res.data.noticeInfoList) {
            for (let t in res.data.noticeInfoList) {
              if (res.data.noticeInfoList[t].agrType === 1046) {
                this.content1046 = res.data.noticeInfoList[t].chgNotice;
                this.show1046 = true;
              } else if (res.data.noticeInfoList[t].agrType === 1047) {
                this.content1047 = res.data.noticeInfoList[t].chgNotice;
                this.show1047 = true;
              }
            }
          } else {
            console.log('获取协议内容异常！');
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 确认个人签名
    confirm: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.dialogVisible = false;
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    handleLink: link => {
      window.open(link, '_blank');
    }
  }
};
</script>
<style lang="less" scoped>
.footer-wrap {
  background: var(--src-bg-color-dark);
  height: auto !important;
  display:flex;
  align-items: center;
  justify-content: center;
  /deep/.xui-dialog__titleBox {
    display: none;
  }
}

.footer-con{
  padding: 67px 0;
  color: var(--src-text-color-white);
}

.footer-link{
  margin:0 30px;
  font-size: var(--src--text-size-medium);
  font-weight: 400;
}

.copyright{
  display:flex;
  margin-top: 57px;
  font-size: var(--src--text-size-small);
  color: var(--src-text-color-white);
}

.copyright-txt{
  color: var(--src-text-color-white);
  display: flex;
  align-items: center;
}

.honor-security-secret-statement,
.honor-security-user-protocol {
  cursor: pointer;
}
// .change-content-wrap{
//   border: 1px solid #000;
// }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue